import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { AuthDataDispatcher } from './auth-data.dispatcher';
import { AuthDataEffects } from './auth-data.effects';
import { FEATURE_NAME, reducer } from './auth-data.reducer';
import { AuthDataResolve } from './auth-data.resolve';
import { AuthDataService } from './auth-data.service';
import { AuthDataStore } from './auth-data.store';
import { AuthHttpService } from './auth-http.service';
import { AuthGuard } from './auth.guard';

export const authDataEffects = [AuthDataEffects];

@NgModule({
  imports: [CommonModule, StoreModule.forFeature(FEATURE_NAME, reducer)],
  declarations: [],
})
export class AuthDataModule {
  static forRoot(): ModuleWithProviders<AuthDataModule> {
    return {
      ngModule: AuthDataModule,
      providers: [
        AuthDataService,
        AuthDataStore,
        AuthHttpService,
        AuthGuard,
        AuthDataDispatcher,
        AuthDataResolve,
      ],
    };
  }
}
